export default __webpack_public_path__ + "static/media/A_r.0f340b52.pdf";